<template>
  <div>
    <div class="tit">
      <img :src="require('@/assets/imgs/shop/hotAreaConRIcon.png')" alt="">
      <span>爆款热卖</span>
    </div>
    <img class="banner" :src="require('@/assets/imgs/shop/hotSellBan.png')" alt="" width="100%">
    <div class="hotSelling">
      <div class="item" v-for="(item, index) in bestGoods">
        <el-tooltip class="item" effect="dark" :content="item.goodsDesc">
          <div class="picWrap"><img class="banner" :src="item.goodsIcon" alt=""></div>
        </el-tooltip>
        <div class="itemR">
          <div class="tit">
            <span>{{ item.goodsName }}</span>
          </div>
          <div class="priceWrap">
            <span class="priceLabel">价格：</span>
            <span class="price">
              <template v-if="item.currencyName == '金龙元宝'">
                <Tip :titInd="0" style="width:25px;vertical-align: bottom"></Tip>
              </template>
              <template v-else-if="item.currencyName == '银龙元宝'">
                <Tip :titInd="1" style="width:25px;vertical-align: bottom"></Tip>
              </template>
              <template v-else-if="item.currencyName == '积分'">
                <Tip :titInd="2" style="width:25px;vertical-align: bottom"></Tip>
              </template>
              <template v-else-if="item.currencyName == '精品券'">
                <Tip :titInd="3" style="width:25px;vertical-align: bottom"></Tip>
              </template>
              {{ item.goodsPrice }}
            </span>
          </div>
          <div v-if="item.vipLevel == 0" class="buyBtn" @click="hotBuy(item)">购买</div>
          <div v-else-if="!(item.vipLevel <= VipGrade)" class="buyBtn" @click="NoBuy(item)" style="color: #fccf46;">
            仅限vip{{ item.vipLevel }}以上购买</div>
          <div v-else class="buyBtn" @click="hotBuy(item)">购买</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Tip from "@/components/Tip";

export default {
  name: "HotSell",
  components: {
    Tip
  },
  props: {
    hotSellData: {},
  },
  data() {
    return {
      bestGoods: this.hotSellData,
      VipGrade: '' //vip等级
    }
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : ''
    if (userInfo) {
      this.VipGrade = Number(userInfo ? userInfo.vipInfo.viplevel.match(/\d+/)[0] : 0)
    }

  },
  methods: {
    hotBuy(item) {               // 热卖购买弹窗
      if (Cookies.get('cwsl_token')) {
        this.$emit('bestBuy', item)
      } else {
        this.$message.error('请先登录')
      }
    },
    NoBuy(item) {
      this.$message.info(`仅限vip${item.vipLevel}以上购买`)
    },
  },
  watch: {
    hotSellData: {
      handler(newv) {
        this.bestGoods = newv

        let userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : ''
        if (userInfo) {
          this.VipGrade = Number(userInfo ? userInfo.vipInfo.viplevel.match(/\d+/)[0] : 0)
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="less">
.tit {
  padding: 10px;

  img {
    margin-right: 8px;
    vertical-align: middle;
  }

  span {
    font-size: 20px;
    vertical-align: middle;
  }
}

.hotSelling {
  .item {
    margin-bottom: 10px;
    padding: 10px;
    overflow: hidden;

    .picWrap {
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border: 2px solid #5472F6;
      box-sizing: border-box;

      img {
        width: 65px;
      }
    }

    .itemR {
      float: left;
      padding-left: 8px;
      width: 140px;

      .tit {
        padding: 0 0 5px 0;

        span {
          padding: 0;
          font-size: 18px;
        }
      }

      .priceWrap {
        margin-bottom: 15px;
        display: flex;

        .priceLabel {
          font-size: 16px;
        }

        .price {
          display: flex;
          font-size: 16px;
          color: #5472F6;
          justify-content: space-evenly;
          align-items: center;
        }
      }

      .buyBtn {
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        background: #5472F6;
      }
    }
  }
}
</style>
